// Out-of-order interstitial dismissals live for the browser session only.
// "Open it anyway" dismisses a single area for the rest of the session.
const PREFIX = "ailab.dismissed.";

export function isAreaDismissed(id) {
  try {
    return window.sessionStorage.getItem(PREFIX + id) === "1";
  } catch {
    return false;
  }
}

export function dismissArea(id) {
  try {
    window.sessionStorage.setItem(PREFIX + id, "1");
  } catch {
    // sessionStorage unavailable, degrade silently.
  }
}

export function clearDismissed() {
  try {
    Object.keys(window.sessionStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => window.sessionStorage.removeItem(k));
  } catch {
    // ignore
  }
}
